'use client';

import type { BrandConfig } from '@lib/config/brand';
import { cn } from '@lib/util/cn';

import NavLogoClient from './nav-logo-client';

export default function MinimalNavClient({
  brand,
  centerLogo = false,
  ariaLabel = 'Primary navigation',
}: {
  brand: BrandConfig;
  centerLogo?: boolean;
  ariaLabel?: string;
}) {
  return (
    <nav
      aria-label={ariaLabel}
      className={cn(
        'w-full desktop:content-container flex items-center h-[60px] desktop:h-[77px] xl:px-10 px-4 desktop:px-6 py-2 desktop:py-0',
        centerLogo ? 'justify-center' : 'justify-center desktop:justify-start',
      )}
    >
      <NavLogoClient brand={brand} disableScrollSwap />
    </nav>
  );
}
